export default __webpack_public_path__ + "static/media/02-manufacturing_thumb.975e8087.png";